import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { getCookie, isWeixinClient, isPcClient, setCookie, getServer } from '@/assets/js/tools';


Vue.use(Router)

var brand_name = ' - 智能派AI';

// if(isIOSEnvironment()){
//   brand_name = ' - FastGPT';
// }

/**
 * keepAlive 缓存页面
 * title 页头
 * distr 需要分销信息页面
 * isPcNull true不显示页面其他元素
 * pc true为pc页面
 */
const router = new Router({
  mode: 'history',
  base: '/chat',
  routes: [
    // PC页面
    {
      path: '/',
      redirect:'/',
      component: () => import('../TaberMobile.vue'),
      children: [
        {
          path: '/',
          name: 'Index',
          component: () => import('../views/pc/Index.vue'),
          meta:{
            // content: true,
            pc: true,
            title: '首页' + brand_name,
          }
        },
      ]
    },
    
    {
      path: '/chatroom',
      name: 'ChatPage',
      component: () => import('../views/pc/ChatPage.vue'),
      meta:{
        // content: true,
        title: '聊天页' + brand_name,
        pc: true,
        // isNoHead: true,
      }
    },
    {
      path: '/vip',
      name: 'VipPurchase',
      component: () => import('../views/pc/VipPurchase.vue'),
      meta:{
        // content: true,
        title: 'VIP开通页' + brand_name,
        pc: true,
        isNoHead: true,
      }
    },
    {
      path: '/setuser',
      name: 'SetUser',
      component: () => import('../views/pc/SetUser.vue'),
      meta:{
        // content: true,
        title: '设置' + brand_name,
        pc: true,
        isNoHead: true,
      }
    },
    {
      path: '/protocol',
      name: 'Protocol',
      component: () => import('../views/pc/Protocol.vue'),
      meta:{
        // content: true,
        title: '用户协议' + brand_name,
        pc: true,
        isNoHead: true,
      }
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: () => import('../views/pc/Feedback.vue'),
      meta:{
        // content: true,
        title: '我的反馈' + brand_name,
        mobileTitle: '我的反馈',
        pc: true,
        isNoHead: true,
      }
    },


    // 移动端页面
    {
      path: '/',
      redirect:'/',
      component: () => import('../Taber.vue'),
      children: [
        {
          path: '/home',
          name: 'Home',
          component: () => import('../views/Home.vue'),
          meta:{
            keepAlive: true,
            title: '推广商品' + brand_name,
            distr: true,
          }
        },
        {
          path: '/kanban',
          name: 'Kanban',
          component: () => import('../views/Kanban.vue'),
          meta:{
            keepAlive: true,
            title: '数据看板' + brand_name,
            distr: true,
          }
        },
        {
          path: '/mine',
          name: 'Mine',
          component: () => import('../views/Mine.vue'),
          meta:{
            keepAlive: true,
            title: '个人中心' + brand_name,
            distr: true,
          }
        },
      ]
    },

    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta:{
        title: '登录/注册' + brand_name,
        // content: true,
        // distr: true,
      }
    },
    {
      path: '/extend',
      name: 'Extend',
      component: () => import('../views/subpage/Extend.vue'),
      meta:{
        title: 'Plus VIP' + brand_name,
        distr: true,
      }
    },
    {
      path: '/promoteVip',
      name: 'PromoteVip',
      component: () => import('../views/subpage/PromoteVip.vue'),
      meta:{
        title: 'Plus VIP' + brand_name,
        distr: true,
        isCanvasSize: 768
      }
    },
    {
      path: '/download',
      name: 'Download',
      component: () => import('../views/download/Download.vue'),
      meta: {
        // content: true,
        title: 'App下载' + brand_name,
      }
    },
    {
      path: '/junior',
      name: 'junior',
      component: () => import('../views/subpage/Junior.vue'),
      meta: {
        title: '团队成员' + brand_name,
        distr: true,
      }
    },
    {
      path: '/records',
      name: 'records',
      component: () => import('../views/withdraw/Records.vue'),
      meta: {
        title: '提现记录' + brand_name,
        distr: true,
      }
    },
    {
      path: '/ApplyOrder',
      name: 'ApplyOrder',
      component: () => import('../views/withdraw/ApplyOrder.vue'),
      meta: {
        title: '提现' + brand_name,
        distr: true,
      }
    },
    {
      path: '/payStatus',
      name: 'PayStatus',
      component: () => import('../views/subpage/PaySuccess.vue'),
      meta:{
        title: 'Plus VIP' + brand_name,
        distr: true,
      }
    },
    {
      path: '/poster',
      name: 'Poster',
      component: () => import('../views/subpage/Poster.vue'),
      meta:{
        title: 'Plus VIP' + brand_name,
        distr: true,
      }
    },
    {
      path: '/become',
      name: 'Become',
      component: () => import('../views/subpage/Become.vue'),
      meta:{
        title: '申请成为推广员' + brand_name,
        distr: true,
      }
    },

    
  ]
})

function setStore(num, num1, val){
  store.commit(num, val);
  localStorage.setItem(num1, val);
  // setCookie(num1, val, 60 * 24 * 30, '.chaodanfan.com');
  $cookies.set(num1, val, 60 * 60 * 24 * 30);
}

// 动态加载样式文件的函数
function loadStyle(filename) {
  const head = document.getElementsByTagName('head')[0]
  const link = document.createElement('link')

  link.rel = 'stylesheet';
  link.href = `/chat/static/css/${filename}?t=${Math.random()}`
  link.setAttribute('data-style', 'dynamic')

  head.appendChild(link)
}

// 移除之前加载的样式文件的函数
function removeStyle() {
  const head = document.getElementsByTagName('head')[0]
  const styles = document.querySelectorAll('link[data-style="dynamic"]')

  for (let i = 0; i < styles.length; i++) {
    head.removeChild(styles[i])
  }
}

function isCssFileLoaded(filename) {
  var linkElements = document.querySelectorAll("link[rel='stylesheet']");
  for (var i = 0; i < linkElements.length; i++) {
    var linkElement = linkElements[i];
    if (linkElement.href && linkElement.href.includes(filename)) {
      return true;
    }
  }
  return false;
}

router.beforeEach((to, from, next) => {
  if(to.name == 'Download'){
    removeStyle();
    next();
    return false;
  }

  if(to.name != 'Login'){
    if(to.meta.pc){
      if(!isCssFileLoaded('common.css')){
        removeStyle();
        loadStyle('common.css');
        loadStyle('theme.css');
      }

      // 移动端访问pc页面切换到下载页
      // if(!isPcClient){
      //   next('/download');
      //   return;
      // }
    } else {
      if(!isCssFileLoaded('common_m.css')){
        removeStyle();
        loadStyle('common_m.css');
      }
    }
  }

  if(store.state.eventSource){
    store.commit('setEventSourceUrl', to);
    return false;
  }
  store.commit('setEventSourceUrl', false);


  if(isWeixinClient()){
    let toAccessToken = to.query.access_token;
    let toLoginToken = to.query.login_token;
    let toWeixinLoginToken = to.query.weixin_login_token;
    
    toWeixinLoginToken && setStore('setWeixinLoginToken', 'aiWeixinLoginToken', toWeixinLoginToken);
    toAccessToken && setStore('setToken', 'aiAccessToken', toAccessToken);
    toLoginToken && setStore('setLoginToken', 'aiLoginToken', toLoginToken);
    
    let WeixinLoginToken = $cookies.get('aiWeixinLoginToken');
    let aiLoginToken = $cookies.get('aiLoginToken');

    if(WeixinLoginToken || aiLoginToken){
      next();
      return false;
    }

    if(!WeixinLoginToken && !store.state.weixinLoginToken){
      let redirect = encodeURIComponent(window.location.href)
      $cookies.remove('aiAccessToken')
      $cookies.remove('aiLoginToken')
      $cookies.remove('aiUserName')
      $cookies.remove('aiWeixinLoginToken')
      
      const qsData = {
        redirect: redirect,
      }
      if(store.state.token){
        qsData.access_token = store.state.token;
      }
      
      let queryString = Object.keys(qsData)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(qsData[key])}`)
      .join('&');
      // window.open('https://www.chaodanfan.com/login/weixinuserlogin?' + queryString);
      location.href = getServer() + '/login/weixinuserlogin?' + queryString;
      return false;
    }
  }
  
  next();
})

router.afterEach((to, from) => {
  // 从路由的元信息中获取 title 属性
  // if (route.meta.title) {
  //   document.title = route.meta.title;
  //   // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
  //   if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  //     const hackIframe = document.createElement('iframe');
  //     hackIframe.id='iframe_title';
  //     hackIframe.style.display = 'none';
  //     hackIframe.src = '/vueStatic/fixIosTitle.html?r=' + Math.random();
  //     document.body.appendChild(hackIframe);
  //     setTimeout(() => {
  //       if(document.getElementById('iframe_title')){
  //         document.body.removeChild(hackIframe)
  //       }
  //     }, 300)
  //   }
  // }

  // 个别页面画布不为375，需要更改计算尺寸
  if(to.meta.isCanvasSize){
    window.canvasSize = to.meta.isCanvasSize;
    refreshFontSize()
  } else {
    window.canvasSize = 468
    refreshFontSize();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js